// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__j_FhB","col":"styles_col__3t022"};